/* sd-notify-me.js
 *
 * Wires up the sd-notify-me form to Klaviyo's public client profiles API.
 * Klaviyo company: VayxQv. Endpoint: /client/profiles/.
 *
 * We capture the email + a human-readable "Notify Request" item property so the
 * team can manually email the (small) waiting list when a SKU restocks. We do
 * NOT use Klaviyo's back-in-stock flow (none is configured and the Shopify
 * catalog isn't synced); a profile property is catalog-independent and readable.
 */

(function() {
  const KLAVIYO_COMPANY_ID = 'VayxQv';
  const ENDPOINT = `https://a.klaviyo.com/client/profiles/?company_id=${KLAVIYO_COMPANY_ID}`;

  function attachHandler(root) {
    const form = root.querySelector('[data-sd-notify-form]');
    if (!form || form.dataset.sdNotifyAttached) return;
    form.dataset.sdNotifyAttached = '1';

    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      const email = form.querySelector('[name=email]').value.trim();
      if (!email) return;

      const variantId = root.dataset.variantId || '';
      const variantLabel = root.dataset.variantLabel || '';
      const productTitle = root.dataset.productTitle || '';
      const item = productTitle && variantLabel
        ? `${productTitle} — ${variantLabel}`
        : (productTitle || variantLabel || 'Unknown item');

      // Disable submit while in flight
      const btn = form.querySelector('button[type=submit]');
      if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }

      try {
        const properties = {
          'Notify Request': item,
          'Notify Request Date': new Date().toISOString().slice(0, 10)
        };
        if (variantId) properties['Notify Variant ID'] = variantId;

        const response = await fetch(ENDPOINT, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'revision': '2024-10-15'
          },
          body: JSON.stringify({
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: properties
              }
            }
          })
        });

        if (response.status >= 200 && response.status < 300) {
          showSuccess(root);
        } else {
          throw new Error(`Klaviyo ${response.status}`);
        }
      } catch (err) {
        console.warn('[sd-notify-me]', err);
        showError(root);
        if (btn) { btn.disabled = false; btn.textContent = 'Notify me when available'; }
      }
    });
  }

  function showSuccess(root) {
    const form = root.querySelector('[data-sd-notify-form]');
    const success = root.querySelector('[data-sd-notify-success]');
    const errorEl = root.querySelector('[data-sd-notify-error]');
    if (form) form.hidden = true;
    if (errorEl) errorEl.hidden = true;
    if (success) success.hidden = false;
  }

  function showError(root) {
    const errorEl = root.querySelector('[data-sd-notify-error]');
    if (errorEl) errorEl.hidden = false;
  }

  // Initial scan
  document.querySelectorAll('[data-sd-notify-root]').forEach(attachHandler);

  // Re-scan after variant change (Dawn re-renders sections)
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-sd-notify-root]').forEach(attachHandler);
  });

  // Section refresh hook (Dawn sectionRendered event for variant changes)
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('[data-sd-notify-root]').forEach(attachHandler);
  });

  // Also watch for variant changes (Dawn dispatches custom events on variant pickers)
  document.addEventListener('change', (e) => {
    if (e.target.matches('input[name="id"]') || e.target.closest('variant-selects, variant-radios')) {
      // Variant changed; the buy-buttons section may have re-rendered
      setTimeout(() => {
        document.querySelectorAll('[data-sd-notify-root]').forEach(attachHandler);
      }, 100);
    }
  });

  // Exposed so the PDP can re-attach the handler immediately after it swaps the
  // launch-mode block on a client-side variant change (innerHTML-inserted forms
  // aren't picked up by the timed re-scan above).
  window.sdNotifyMeRescan = function () {
    document.querySelectorAll('[data-sd-notify-root]').forEach(attachHandler);
  };
})();
